import { decode } from 'html-entities';

const stripTagsFallback = (value: string) => value.replace(/<[^>]*>/g, '');

export const decodeHtml = (input = '') => decode(input);
export const removeTags = (input = '') => {
  const decoded = decode(input);
  if (typeof DOMParser === 'undefined') {
    return stripTagsFallback(decoded);
  }

  const doc = new DOMParser().parseFromString(decoded, 'text/html');
  return doc.body?.textContent || '';
};

const ALLOWED_LINK_PROTOCOLS = /^(https?:|mailto:|tel:|#|\/)/i;

export const sanitizeUnsafeLinks = (html: string) => {
  if (typeof DOMParser === 'undefined') {
    return html;
  }

  const doc = new DOMParser().parseFromString(html, 'text/html');

  doc.querySelectorAll('a[href]').forEach((anchor) => {
    const href = decodeHtml(anchor.getAttribute('href') ?? '').trim();

    if (!ALLOWED_LINK_PROTOCOLS.test(href)) {
      anchor.removeAttribute('href');
    }
  });

  return doc.body.innerHTML;
};
